import { cn } from '@/lib/utils'

type RichTextCharCountProps = {
  current: number
  max: number
  className?: string
}

/** Character limit readout — pin in artifact footer opposite action buttons. */
export function RichTextCharCount({ current, max, className }: RichTextCharCountProps) {
  return (
    <p
      className={cn('text-xs text-muted-foreground tabular-nums', className)}
      aria-live="polite"
    >
      {current} / {max}
    </p>
  )
}
